import { Accepts, Types } from "@citychallenge/common";
import { Inlet, Outlet } from "../../reactive";
import { defineElement } from "../define-element";

export class ImageHotspotsProps {
  @Inlet(Accepts.Image) public image!: Types["Image"];
  @Inlet(Accepts.ActionPointList) public options!: Types["ActionPointList"];
  @Inlet(Accepts.MarkdownText) public text?: Types["MarkdownText"];

  @Inlet(Accepts.Subtitles) public subtitles?: Types["Subtitles"];
  @Inlet(Accepts.TimeRange) public loop?: Types["TimeRange"];

  @Inlet(Accepts.Boolean) public zoomable?: Types["Boolean"];
  @Inlet(Accepts.Boolean) public allowReselecting?: Types["Boolean"];
  @Inlet(Accepts.ChoiceMode) public answerMode?: Types["ChoiceMode"];
  @Inlet(Accepts.Boolean) public isRequired?: Types["Boolean"];

  @Outlet({
    arguments: {
      // Accepts number
      option: {
        type: Accepts.GeoMarker,
        inlet: "options",
      },
    },
    repeatable: true,
  })
  public chosenOption?: (value: { option: Types["ActionPoint"] }) => void;

  @Outlet({
    arguments: {
      // Accepts number
      option: {
        type: Accepts.GeoMarker,
        inlet: "options",
      },
    },
    repeatable: true,
  })
  public tapOnHotspot?: (value: { option: Types["ActionPoint"] }) => void;
}

export const ImageHotspotsDefinition = defineElement(
  "image-hotspots",
  ImageHotspotsProps,
  {
    versionRequired: "0.50.0",
  }
);
